import {z} from 'zod';

import i18n from '@dms/i18n';

export const locationFormSchema = z.object({
  name: z
    .string({
      required_error: i18n.t('general.validations.fieldIsRequired'),
    })
    .trim()
    .min(1, i18n.t('general.validations.fieldIsRequired')),
});

export type LocationFormType = z.infer<typeof locationFormSchema>;
